module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/core-js@1.2.7/node_modules/core-js/library/modules/$.redefine.js
// module id = iv/G
// module chunks = 0